import text from './text.json'
import {SimpleBlueButton} from '../../components/core/button'
import {getProration, getSubscriptionPayments, updateSubscription} from '../../stores/payment'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {routes} from '../../routes'
import {useEffect, useState} from 'react'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import AmountManager from '../../utils/amount'
import TextHelper from '../../utils/text'
import SkeletonLoader from '../../components/core/skeletonLoader'
import classNames from 'classnames'
import {CurrencyMsgIcon} from '../../icons'

const UpgradeModal = ({setModal, modal, getUpgradeIsEnabled, findPlanData, findPlanPriceId, paymentInterval, isTrialPeriod, getPriceSymbol, currency, plansData}) => {
    const subscriptions = useSelector(state => state.payment.subscriptions)
    const subscriptionId = subscriptions?.data?.subscriptions?.find(subscription => subscription?.active === true)?.subscription_id
    const paymentData = useSelector(state => state.payment.paymentData)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const customerCurrency = paymentData?.data?.subscription?.payments?.[0]?.currency
    const [loader, setLoader] = useState(false)
    const [isFetching, setIsFetching] = useState(true)
    const prorationData = useSelector(state => state.payment.prorationData)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const upgrade = async() => {
        const success = await dispatch(updateSubscription(setLoader, subscriptionId, {
            price_id: modal?.priceId,
            coupon_code: localStorage.getItem('coupon')
        }))

        if (success) {
            localStorage.removeItem('coupon')
            setModal(false)
            navigate(`${routes.subscription_success.path}/?session_id=true`)
            return
        }
        navigate(routes.subscription_cancel.path)
    }

    const getPlanName = (key, interval) => {
        const name = plansData?.find(plan => plan.key === key)?.display_name
        return `${TextHelper.capitalizeFirstChar(name || '')} plan (${interval})`
    }

    const getIntervalPrice = (key, interval, currency) => {
        const plan = findPlanData(key, interval, currency)
        return `${AmountManager.normalizePrice(plan?.amount, getPriceSymbol)}`
    }

    const fetchProrations = async() => {
        await dispatch(getProration(setIsFetching, subscriptionId, findPlanPriceId(modal?.key, paymentInterval)))
    }

    const fetchSubscriptionPayments = async() => {
        await dispatch(getSubscriptionPayments(subscriptionId))
    }

    useEffect(() => {
        if (subscriptionId) {
            fetchSubscriptionPayments()
        }
    }, [subscriptionId])

    useEffect(() => {
        if (subscriptionId && modal?.key && customerCurrency && customerCurrency === currency) {
            fetchProrations()
        }
    }, [modal, subscriptionId, customerCurrency])

    return (
        customerCurrency && customerCurrency !== currency ? <div className={classNames('info-modal', {
            dark: isDarkMode
        })}>
            <CurrencyMsgIcon/><span>{text.different_currency_message}</span> </div> : isFetching ? (
            <div className="details">
                {Array.from({length: 10}).map((item, index) => (
                    <SkeletonLoader key={index}/>
                ))}
            </div>
        ) : (
            <>
                <div className={classNames('details', {
                    dark: isDarkMode
                })}>
                    <span className="note">
                        <span className="badge">{text.note}</span>
                        {isTrialPeriod ? text.modal_trial_note : text.modal_note}
                    </span>
                    <div className="title">
                        {text.details}
                    </div>
                    <ul>
                        <h4>{text.current_plan}</h4>
                        <li className="amount-info">
                            <span
                                className="plan-name">{getPlanName(prorationData?.plans?.current?.plan, prorationData?.plans?.current?.interval)}</span>
                            <span>{!isTrialPeriod && getIntervalPrice(prorationData?.plans?.current?.plan, prorationData?.plans?.current?.interval, prorationData?.plans?.new?.currency)}</span>
                        </li>
                        <li className="amount-info">
                            <span>{isTrialPeriod ? text.trial : text.unused}</span>
                            <span>{isTrialPeriod ? '0' : AmountManager.normalizePrice(prorationData?.plans?.current?.amount, getPriceSymbol)}</span>
                        </li>
                    </ul>
                    <ul>
                        <h4>{text.new_plan}</h4>
                        <li className="amount-info">
                            <span
                                className="plan-name">{getPlanName(prorationData?.plans?.new?.plan, prorationData?.plans?.new?.interval)}</span>
                            <span>{getIntervalPrice(prorationData?.plans?.new?.plan, prorationData?.plans?.new?.interval, prorationData?.plans?.new?.currency)}</span>
                        </li>
                    </ul>
                    {
                        !isTrialPeriod && (
                            <ul>
                                <li className="amount-info">
                                    <span>{text.unused}</span>
                                    <span>{AmountManager.normalizePrice(prorationData?.plans?.current?.amount, getPriceSymbol)}</span>
                                </li>
                                <li className="amount-info">
                                    <span>{text.excluding_tax}</span>
                                    <span>{AmountManager.normalizePrice(prorationData?.difference?.amount, getPriceSymbol)}</span>
                                </li>
                                {prorationData?.difference?.tax?.amount > 0 && (
                                    <li className="amount-info">
                                        <span>{text.tax.replace(':percent', prorationData?.difference?.tax?.percent)}</span>
                                        <span>{AmountManager.normalizePrice(prorationData?.difference?.tax?.amount, getPriceSymbol)}</span>
                                    </li>
                                )}
                            </ul>
                        )
                    }
                    <ul>
                        <li>
                            <span>{text.total}</span>
                            <span>{
                                isTrialPeriod ? '0' : AmountManager.normalizePrice(prorationData?.difference?.total, getPriceSymbol)
                            }</span>
                        </li>
                    </ul>
                    {getUpgradeIsEnabled(modal?.key) && (
                        <SimpleBlueButton
                            className="upgrade-button"
                            disabled={loader}
                            onClick={upgrade}>
                            {loader && <ButtonLoader/>}
                            {text.upgrade}
                        </SimpleBlueButton>

                    )}
                </div>
            </>
        )
    )
}

export default UpgradeModal
